import SimpleBar from 'simplebar'

document.querySelectorAll('.list--downloads input[type="checkbox"]').forEach(function (checkbox) {
	checkbox.addEventListener('change', function () {
		var downloadsLength = document.querySelectorAll('.list--downloads input[type="checkbox"]:checked').length

		document.querySelectorAll('span.downloads--number').forEach(function (el) {
			el.textContent = downloadsLength
		})
	})
})

var scrollbar

document.querySelectorAll('.scroll').forEach(function (el) {
	if (el.closest('.section--map') || el.closest('.nav--main')) {
		return
	}

	scrollbar = new SimpleBar(el, { autoHide: false })
})

document.querySelectorAll('.nav--panels a').forEach(function (link) {
	link.addEventListener('click', function (e) {
		e.preventDefault()

		scrollbar.getScrollElement().scrollTop = 0

		document.querySelectorAll('.nav--panels a').forEach(function (a) {
			a.classList.remove('tab--active')
		})
		link.classList.add('tab--active')

		var panel = link.getAttribute('href')

		if (panel == '#panel--all') {
			document.querySelectorAll('.panel').forEach(function (p) {
				p.classList.add('panel--active')
				p.setAttribute('aria-hidden', 'false')
			})
		} else {
			document.querySelectorAll('.panel').forEach(function (p) {
				p.classList.remove('panel--active')
				p.setAttribute('aria-hidden', 'true')
			})

			var target = document.querySelector(panel)
			if (target) {
				target.classList.add('panel--active')
				target.setAttribute('aria-hidden', 'false')
			}
		}
	})
})
